__turbopack_context__.v({
  "content": "FiltersPanelSkeletonLoader-module__fbvpzG__content",
  "root": "FiltersPanelSkeletonLoader-module__fbvpzG__root",
  "tag": "FiltersPanelSkeletonLoader-module__fbvpzG__tag",
  "tags": "FiltersPanelSkeletonLoader-module__fbvpzG__tags",
  "title": "FiltersPanelSkeletonLoader-module__fbvpzG__title",
});
